/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NewResourceResponse
 */
export interface NewResourceResponse {
    /**
     * 
     * @type {string}
     * @memberof NewResourceResponse
     */
    id: string | null;
    /**
     * 
     * @type {any}
     * @memberof NewResourceResponse
     */
    etc: any | null;
}

export function NewResourceResponseFromJSON(json: any): NewResourceResponse {
    return NewResourceResponseFromJSONTyped(json, false);
}

export function NewResourceResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): NewResourceResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'etc': json['etc'],
    };
}

export function NewResourceResponseToJSON(value?: NewResourceResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'etc': value.etc,
    };
}

